import { useState } from "react";
import { toast } from "sonner";
import { Link2, Loader2, Sparkles } from "lucide-react";
import { adminApi, formatApiError } from "@/context/AuthContext";

// « Import par lien » : Claude reads the concert page and pre-fills the form (nothing is saved yet)
export const ImportFromLink = ({ onImport }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!url.trim()) return;
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/events/import", { url: url.trim() });
      onImport(data);
      if (data?.duplicate) toast.warning(`Attention : « ${data.duplicate.title} » existe déjà à cette date.`);
      else toast.success("Fiche préremplie : vérifie les infos avant d'enregistrer.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-primary/60 bg-primary/10 p-4" data-testid="event-import">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-white">
        <Sparkles className="w-4 h-4 text-primary" /> Importer depuis un lien
      </p>
      <p className="text-zinc-300 text-sm mt-1">Colle la page du concert (salle, billetterie…) : la fiche se remplit toute seule.</p>
      <div className="flex mt-3 border border-white/30 focus-within:border-white">
        <Link2 className="w-4 h-4 text-zinc-400 self-center ml-3 shrink-0" />
        <input type="url" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…" data-testid="event-import-url"
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); run(); } }}
          className="flex-1 min-w-0 bg-transparent text-white placeholder:text-zinc-400 px-3 h-11 outline-none" />
        <button type="button" onClick={run} disabled={busy || !url.trim()} data-testid="event-import-btn"
          className="inline-flex items-center gap-2 bg-white text-black uppercase text-xs font-bold tracking-[0.15em] px-4 hover:bg-primary hover:text-white transition-colors disabled:opacity-50">
          {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Lecture…</> : "Remplir"}
        </button>
      </div>
    </div>
  );
};
